import styled from "@emotion/styled/macro";
import { colors } from "../../../../../../common/styles/theme.styles";

export const TagEditorModalWrapper = styled.div`
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const TagEditorModalClose = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    color: ${colors.darkGray2};
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    
    &:hover {
        color: ${colors.darkGray1};
    }
`;

export const TagEditorModalHeader = styled.div`
    padding: 24px;
    border-bottom: 1px solid ${colors.gray3};
`;

export const DocumentTypeHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const DocumentInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const DocumentTitle = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
`;

export const DocumentBadge = styled.div`
    background: #1A1B1D;
    color: #FFFFFF;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Circular;
    font-weight: 450;
    font-size: 11px;
    line-height: 1.265;
`;

export const DocumentIcon = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TagEditorModalBody = styled.div`
    flex: 1;
    padding: 24px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const CreateTagSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const CreateTagLabel = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 12px;
    line-height: 1.265;
    color: #9097A3;
    padding: 2px 0;
`;

export const CreateTagInputWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 8px 0 16px;
    border: 1px solid #585D66;
    border-radius: 12px;
    height: 48px;
    position: relative;
`;

export const AddCustomTagButton = styled.button`
    display: flex;
    height: 36px;
    padding: 0px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 10px;
    background: var(--Main-Colors-Dark-Grey-1, #1A1B1D);
    border: none;
    cursor: pointer;
    flex-shrink: 0;

    color: var(--White, #FFF);
    font-size: 14px;
    font-weight: 450;
    line-height: normal;

    &:hover {
        background: #2A2B2D;
    }
`;

export const PlusIcon = styled.div`
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const CreateTagInput = styled.input`
    border: none;
    outline: none;
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #1A1B1D;
    flex: 1;
    background: transparent;
    
    &::placeholder {
        color: #9097A3;
    }
`;

export const TagSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TagSectionTitle = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 12px;
    line-height: 1.265;
    color: #9097A3;
    padding: 2px 0 8px 0;
`;

export const SelectedTagsWrapper = styled.div`
    border-radius: 6px;
    padding: 6px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const SelectedTag = styled.div`
    background: #1A1B1D;
    width: fit-content;
    border-radius: 37px;
    padding: 6px 12px 6px 10px;
    cursor: pointer;
`;

export const SelectedTagContent = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const SelectedTagIcon = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SelectedTagText = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 14px;
    line-height: 1.265;
    color: #FFFFFF;
    flex: 1;
`;

export const CheckmarkIcon = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const AllTagsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding-bottom: 96px;
`;

export const TagOption = styled.div`
    border-radius: 6px;
    width: fit-content;
    padding: 0;
    cursor: pointer;
`;

export const TagOptionContent = styled.div`
    background: #F1F3F5;
    border-radius: 37px;
    padding: 6px 16px 6px 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: background-color 0.2s ease;
    
    &:hover {
        background: #E8EAED;
    }
`;

export const TagOptionIcon = styled.div`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const TagOptionText = styled.div`
    font-family: Circular;
    font-weight: 450;
    font-size: 13px;
    line-height: 1.265;
    color: #1A1B1D;
`;

export const SaveButtonContainer = styled.div`
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
    padding: 16px 0px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    pointer-events: none;
`;

export const SaveButton = styled.button`
    background: #1A1B1D;
    color: #FFFFFF;
    border: none;
    border-radius: 40px;
    padding: 0 32px;
    height: 48px;
    font-family: Circular;
    font-weight: 450;
    font-size: 16px;
    line-height: 1.265;
    cursor: pointer;
    width: 444px;
    box-shadow: 0px 0.5px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 2px 0px rgba(0, 0, 0, 0.25);
    pointer-events: auto;
    
    &:hover {
        background: #2A2B2D;
    }
`; 